import { render, staticRenderFns } from "./add.vue?vue&type=template&id=3fb186bd&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=3fb186bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb186bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb186bd')) {
      api.createRecord('3fb186bd', component.options)
    } else {
      api.reload('3fb186bd', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=3fb186bd&scoped=true", function () {
      api.rerender('3fb186bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/deliveryNote/add.vue"
export default component.exports